import { create, clickable, collection, isPresent, text, visitable } from 'ember-cli-page-object';
export default create({
  visit: visitable('/public/:registry/boxes/:box'),
  titleFull: text('[data-test-box-id]'),
  titleBadge: text('[data-test-box-id] .hds-badge'),
  get title() {
    return this.titleFull.split(' ')[0];
  },
  shortDescription: text('[data-test-short-description]'),
  latestVersionId: text('[data-test-box-latest-version]'),
  providers: collection('[data-test-provider] > li', {
    id: text('h3'),
    isEmpty: isPresent('div + em'),
    architectures: collection('> ol > li', {
      type: text('span'),
      url: text('[data-test-description="external"]'),
      hasUrl: isPresent('[data-test-description="external"]'),
      size: text('[data-test-description="hosted"]'),
      hasSize: isPresent('[data-test-description="hosted"]'),
      download: clickable('[data-test-download]')
    })
  })
});